/* APOLICES */
export const CREATE_APOLICE = "CREATE_APOLICE"
export const CREATE_APOLICE_SUCCESS = "CREATE_APOLICE_SUCCESS"
export const CREATE_APOLICE_FAIL = "CREATE_APOLICE_FAIL"
export const UPDATE_APOLICE = "UPDATE_APOLICE"
export const UPDATE_APOLICE_SUCCESS = "UPDATE_APOLICE_SUCCESS"
export const UPDATE_APOLICE_FAIL = "UPDATE_APOLICE_FAIL"
export const DELETE_APOLICE = "DELETE_APOLICE"
export const DELETE_APOLICE_SUCCESS = "DELETE_APOLICE_SUCCESS"
export const DELETE_APOLICE_FAIL = "DELETE_APOLICE_FAIL"

